(function(){
  try {
    /**
     * ResourceTimingSDK
     * 用于统计页面资源加载耗时，并过滤掉缓存资源
     */
    class ResourceTimingSDK {
      constructor(options = {}) {
        this.options = {
          // 是否自动上报
          autoReport: false,
          // 上报回调函数
          onReport: () => {},
          ...options
        };
        
        this.observer = null;
        this.init();
      }

      init() {
        // 1. 统计页面初始化时已加载的资源
        if (document.readyState === 'complete') {
          this.collectExistingResources();
        } else {
          window.addEventListener('load', () => {
            // 稍微延迟以确保 load 事件中的资源也被捕获
            setTimeout(() => this.collectExistingResources(), 0);
          });
        }

        // 2. 开启实时监控（针对懒加载资源、接口请求等）
        this.startObserver();
      }

      /**
       * 收集当前已存在的资源列表
       */
      collectExistingResources() {
        const resources = performance.getEntriesByType('resource');
        const validResources = resources
          .map(entry => this.formatEntry(entry))
          .filter(item => item !== null); // 过滤掉被判定为缓存的资源

        if (validResources.length > 0) {
          this.report(validResources);
        }
      }

      /**
       * 开启 PerformanceObserver 监听后续资源
       */
      startObserver() {
        if (!('PerformanceObserver' in window)) return;

        this.observer = new PerformanceObserver((list) => {
          const entries = list.getEntries();
          const validResources = entries
            .map(entry => this.formatEntry(entry))
            .filter(item => item !== null);

          if (validResources.length > 0) {
            this.report(validResources);
          }
        });

        this.observer.observe({ entryTypes: ['resource'] });
      }

      /**
       * 格式化并过滤资源数据
       * @param {PerformanceResourceTiming} entry 
       * @returns {Object|null} 如果是缓存资源返回 null，否则返回格式化后的数据
       */
      formatEntry(entry) {
        // --- 核心过滤逻辑 ---
        
        // 1. 过滤掉非 HTTP(S) 协议（如 blob:, data: 等）
        if (!entry.name.startsWith('http')) {
          return null;
        }

        // 2. 缓存判断逻辑
        // 如果 transferSize 为 0，说明是从缓存读取（Disk/Memory Cache），直接过滤
        // 注意：跨域资源如果未设置 Timing-Allow-Origin，transferSize 也会是 0，
        // 但为了严格过滤缓存，这里通常会一并过滤掉（或者你可以选择保留但标记为未知）
        if (entry.transferSize === 0) {
          return null; 
        }

        // --- 数据组装 ---
        
        return {
          name: entry.name, // 资源 URL
          type: entry.initiatorType, // 资源类型 (script, css, img, xmlhttprequest, fetch...)
          duration: {
            value: Math.round(entry.duration), // 加载总耗时 (ms)
            unit: 'ms'
          },
          size: {
            value: Number((entry.transferSize / 1024).toFixed(2)), // 传输大小 (KB)
            unit: 'KB'
          },
          decodedSize: {
            value: Number((entry.decodedBodySize / 1024).toFixed(2)), // 解压后大小 (KB)
            unit: 'KB'
          },
          
          // 详细网络耗时阶段
          timing: {
            pending: Math.max(0, Math.round(entry.requestStart - entry.startTime)), // Pending（请求发起前等待）
            dns: Math.round(entry.domainLookupEnd - entry.domainLookupStart), // DNS查询(ms)
            tcp: Math.round(entry.connectEnd - entry.connectStart), // TCP连接
            ttfb: Math.round(entry.responseStart - entry.requestStart), // 首字节时间(ms)
            download: Math.round(entry.responseEnd - entry.requestStart) // 除去Pending后的下载耗时(ms)
          },
        };
      }

      report(data) {
        if (this.options.autoReport && typeof this.options.onReport === 'function') {
          this.options.onReport(data);
        }
      }
    }

    // --- 使用示例 ---

    // 初始化 SDK
    const resourceMonitor = new ResourceTimingSDK({
      autoReport: true,
      onReport: (resources) => {
        // 这里可以发送数据到你的后端服务器
        resources.forEach(res => {
          if( 
            !['other', 'xmlhttprequest', 'fetch', 'beacon', 'iframe'].includes(res.type) && 
            res.timing.download > 1000 &&
            res.timing.download > 1000 && // 下载耗时大于 1s
            res.size.value > 20 // 图片大于 20 KB
          ) {
            const reportData = {
              resource_name: res.name, // 资源 URL
              resource_type: res.type, // 资源类型 (script, css, img, xmlhttprequest, fetch...)
              total_duration: res.duration.value, // 加载总耗时，含 pending (ms)
              resource_size: res.size.value, // 文件大小 (KB)
              download_duration: res.timing.download, // 下载耗时 (ms)
            }

            Shopify.analytics.publish("performance_monitoring", reportData);
          }
        });
      }
    });

  } catch (e) {
    window.report_faro({
      file_name: 'assets/resource-timing.js',
      func_name: 'resourceTimingInit',
      desc: 'Resource performance tracking failed',
      error: e
    });
  }
})();
